import { useEffect } from "react";

const PHONE_SYSTEM_URL =
  process.env["REACT_APP_3CX_PHONESYSTEM_URL"] || "https://1166.3cx.cloud";
const PARTY = process.env["REACT_APP_3CX_PARTY"] || "krentapplimited";
const SCRIPT_ID = "tcx-callus-js";
const SCRIPT_SRC =
  "https://downloads-global.3cx.com/downloads/livechatandtalk/v1/callus.js";
const ROOT_ID = "krent-3cx-root";

/**
 * 3CX live chat / call widget.
 * Anchored in #krent-3cx-root so it shares the same right edge as WhatsApp/Tawk.
 */
const ThreeCXCallUs = () => {
  useEffect(() => {
    let root = document.getElementById(ROOT_ID);
    if (!root) {
      root = document.createElement("div");
      root.id = ROOT_ID;
      document.body.appendChild(root);
    }

    root.innerHTML = `
      <call-us
        class="krent-3cx-widget"
        phonesystem-url="${PHONE_SYSTEM_URL}"
        style="position:absolute;right:0;bottom:0;font-size:14px;line-height:15px;z-index:20045;--call-us-main-accent-color:#47D6D6;--call-us-main-background-color:#FFFFFF;--call-us-plate-background-color:#206C77;--call-us-plate-font-color:#E6E6E6;--call-us-main-font-color:#292929;--call-us-agent-bubble-color:#29292910;transform:scale(0.85);transform-origin:bottom right;"
        id="wp-live-chat-by-3CX"
        minimized="false"
        animation-style="fadein"
        party="${PARTY}"
        minimized-style="bubbleright"
        allow-call="true"
        allow-video="false"
        allow-soundnotifications="true"
        enable-mute="true"
        enable-onmobile="true"
        offline-enabled="true"
        enable="true"
        ignore-queueownership="false"
        authentication="both"
        operator-name="Esther"
        show-operator-actual-name="true"
        aknowledge-received="true"
        gdpr-enabled="true"
        gdpr-message="I have read and agree to the Privacy Policy and consent to the processing of my personal data for the purpose of handling my enquiry."
        message-userinfo-format="both"
        message-dateformat="both"
        lang="browser"
        button-icon-type="default"
        greeting-visibility="none"
        greeting-offline-visibility="none"
        chat-delay="2000"
        enable-direct-call="true"
        enable-ga="false"
      ></call-us>
    `;

    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.defer = true;
      script.src = SCRIPT_SRC;
      script.charset = "utf-8";
      document.body.appendChild(script);
    }

    const alignToColumn = () => {
      const slot = document.getElementById(ROOT_ID);
      const el =
        document.getElementById("wp-live-chat-by-3CX") ||
        document.querySelector("call-us.krent-3cx-widget");
      if (!(slot instanceof HTMLElement) || !(el instanceof HTMLElement)) return;

      // Keep slot on the shared FAB column edge
      slot.style.setProperty("position", "fixed", "important");
      slot.style.setProperty("right", "var(--support-widget-right)", "important");
      slot.style.setProperty("bottom", "var(--support-call-bottom)", "important");
      slot.style.setProperty("left", "auto", "important");
      slot.style.setProperty("top", "auto", "important");

      el.style.setProperty("position", "absolute", "important");
      el.style.setProperty("right", "0", "important");
      el.style.setProperty("bottom", "0", "important");
      el.style.setProperty("left", "auto", "important");
      el.style.setProperty("top", "auto", "important");
      el.style.setProperty("transform", "scale(0.85)", "important");
      el.style.setProperty("transform-origin", "bottom right", "important");

      // Correct any horizontal drift so the bubble lines up with WhatsApp/Tawk
      const anchor =
        document.querySelector<HTMLElement>(".krent-whatsapp-launcher") ||
        document.querySelector<HTMLElement>(".krent-tawk-launcher") ||
        document.querySelector<HTMLElement>(".krent-tawk-close");
      if (!anchor) return;

      const anchorRight = anchor.getBoundingClientRect().right;
      const bubbleRight = el.getBoundingClientRect().right;
      const drift = anchorRight - bubbleRight;
      if (Math.abs(drift) > 1) {
        const currentRight = Number.parseFloat(getComputedStyle(slot).right) || 16;
        slot.style.setProperty(
          "right",
          `${Math.max(0, currentRight - drift)}px`,
          "important",
        );
      }
    };

    alignToColumn();
    const interval = window.setInterval(alignToColumn, 400);

    return () => {
      window.clearInterval(interval);
      const existing = document.getElementById(ROOT_ID);
      if (existing) existing.remove();
    };
  }, []);

  return null;
};

export default ThreeCXCallUs;
